export default {
    data: () => ({
        supplier_transactions: []
    }),
    methods: {
        async supplierTransactionsGet(supplier_name = '', service = '') {
            const result = this.$communicator.then(this, await this.$communicator('supplier_transactions', {
                params: {
                    limit: 10,
                    page: this.page,
                    supplier_name: supplier_name,
                    service: service
                }
            }))
            if (result && result.data instanceof Array) {
                this.supplier_transactions = result.data;
                this.suppliers_total = Math.ceil(result.total / 10)
            }
            else {
                this.supplier_transactions = [];
            }
        }
    }
}